import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface AlertProps {
  variant?: 'info' | 'success' | 'warning' | 'destructive';
  title?: string;
  children: ReactNode;
  className?: string;
}

const variantStyles: Record<NonNullable<AlertProps['variant']>, string> = {
  info: 'border-border bg-accent text-foreground',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-900',
  warning: 'border-amber-200 bg-amber-50 text-amber-900',
  destructive: 'border-red-200 bg-red-50 text-red-900',
};

export function Alert({ variant = 'info', title, children, className }: AlertProps) {
  return (
    <div
      role="status"
      className={cn(
        'rounded-lg border px-4 py-3 text-sm leading-relaxed shadow-sm',
        variantStyles[variant],
        className,
      )}
    >
      {title ? <p className="mb-1 font-semibold">{title}</p> : null}
      <div className="space-y-1">{children}</div>
    </div>
  );
}
